import { Col, Row } from "antd";
import React, { useRef, useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaImage } from "react-icons/fa";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import styles from "./EditAdds.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { AdvertisementMiddleware } from "../../../../Store/Middlewares/AdvertisementMiddleware";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const EditAdds = () => {
  const { state } = useLocation();
  const item = state?.item;
  const [type, setType] = useState(item?.text == null ? "Pictorial" :  "Text & Pictorial");
  const [addImg, setAddImg] = useState(
    state?.item?.image ? state?.item?.image : null
  );
  const [img, setImg] = useState(
    // item?.image
    null
  );
  console.log("type", type);

  const [title, setTitle] = useState(item?.title);
  const [note, setNote] = useState(item?.text ? item?.text : null);
  const dispatch = useDispatch();
  const imgRef = useRef();
  const navigate = useNavigate();
  const onUpdateAdd = () => {
    if (!title || !(img || addImg) || (type == "Text & Pictorial" && !note)) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory.",
        })
      );
    } else {
      let data = {
        id: item?.id,
        title: title,
        type: type,
        text: type == "Text & Pictorial" ? note : null,
        document: img ? img : null,
      };
      dispatch(AdvertisementMiddleware.updateAdvertisement(data))
        .then(() => {
          navigate(-1);
        })
        .catch(() => {});
    }
  };
  return (
    <>
      <Row className={styles.mainCont}>
        <Col className={styles.col}>
          <InputField
            label="Title"
            placeholder={"Photography Services"}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <DropDown
            placeholder={"Text & Pictorial"}
            label={"Ad Type"}
            selectedValue={type}
            onChange={setType}
            options={[
              { value: "Text & Pictorial", option: "Text & Pictorial" },
              { value: "Pictorial", option: "Pictorial" },
            ]}
          />
          {type == "Text & Pictorial" && (
            <TextareaField
              label={"Add Note"}
              placeholder="Please Enter Note "
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          )}
        </Col>

        <Col className={styles.col}>
          {/* <Row className={styles.imgCont}>
          <FaCamera color="#C6C6C6" size={70} />
          <TextCompon
          ent text="Take A Photo" textClass={styles.text} />
        </Row> */}

          <>
            {img || addImg ? (
              <>
                <Row className={styles.crossIcon}>
                  <CgClose
                    size={25}
                    color="var(--primary-color)"
                    onClick={() => {
                      setImg(null);
                      setAddImg(null)
                    }}
                    cursor={"pointer"}
                  />
                </Row>
                <Row className={styles.imgCont}>
                  <img src={img ? URL.createObjectURL(img) : addImg} alt="" />
                </Row>
              </>
            ) : (
              <Row
                className={styles.selimgCont}
                onClick={() => imgRef.current.click()}
              >
                <FaImage color="#C6C6C6" size={70} />
                <TextComponent text="Upload an Image" textClass={styles.text} />
              </Row>
            )}
          </>
        </Col>

        <input
          type="file"
          accept=".jpg,.png,.gif,.jpeg"
          // multiple
          onChange={(e) => {
            setImg(e.target.files[0]);
            imgRef.current.value = "";
          }}
          ref={imgRef}
          className={styles.displayNone}
        />
      </Row>

      <SubmitButton title="Save" btnClass={styles.btn} onClick={onUpdateAdd} />
    </>
  );
};

export default EditAdds;
